import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import styled from 'foundations-theming/utils';
import { filterTokenProps } from 'foundations-components/utils/filterTokenProps';
import { useMapTokenPropsToCSS } from 'foundations-components/hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
// styled.th is required here because TableHeaderCell has no props for
// the border overrides or the typography token.
const StyledTh = styled.th.withConfig({
  displayName: "StyledTableHeaderCell__StyledTh"
})(["&&{", " ", "}&&:not(:first-child){", "}&&&{border-inline-end:none;border-inline-start:none;border-block-start:none;}", ""], ({
  theme
}) => `
      background-color: ${theme.color['fill-surface-default']};
      block-size: ${theme.space['800']};
      padding-block-start: ${theme.space['100']};
    `, ({
  theme
}) => theme.typography['body-125'], ({
  theme
}) => `
      padding-inline: ${theme.space['400']};
    `, ({
  $cssStyles
}) => $cssStyles);
export const StyledTableHeaderCell = _ref => {
  let rest = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  const {
    tokenProps,
    restProps
  } = filterTokenProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledTh, Object.assign({
    $cssStyles: cssStyles
  }, restProps));
};